//
// GENERATED by KVision
//
package pl.finn.forms.sekap1794

import org.w3c.fetch.RequestInit
import io.kvision.remote.KVRemoteAgent
import kotlinx.serialization.modules.SerializersModule
import pl.finn.forms.Zalacznik
import pl.finn.forms.sekap1794.Sekap1794Form
import pl.finn.forms.sekap1794.Sekap1794FormData

actual class Sekap1794Service(serializersModules: List<SerializersModule>? = null, requestFilter: (suspend RequestInit.() -> Unit)? = null) : ISekap1794Service, KVRemoteAgent<Sekap1794Service>(Sekap1794ServiceManager, serializersModules, requestFilter) {
    override suspend fun nowy(token: String) = call(ISekap1794Service::nowy, token)
    override suspend fun edycja(token: String) = call(ISekap1794Service::edycja, token)
    override suspend fun zapisz(sekap1794Form: Sekap1794Form, zalaczniki: List<Zalacznik>, validateResult: String?, token: String) = call(ISekap1794Service::zapisz, sekap1794Form, zalaczniki, validateResult, token)
    override suspend fun podglad(sekap1794Form: Sekap1794Form, zalaczniki: List<Zalacznik>, token: String) = call(ISekap1794Service::podglad, sekap1794Form, zalaczniki, token)
}
